<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Agencias</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="showAddModal = true">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Agencia</span>
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item.value"
                  :label="item.descripcion"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>
  
              <div>
                <form class="apolo-borde">
                  <base-input
                    v-model="query"
                    type="search"
                    append-icon="fas fa-search"
                    placeholder="Buscar..."
                    clearable
                    inputClasses="apolo-borde"
                  />
                </form>
              </div>
            </div>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="agencias"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>
              <div slot="empty" v-if="agencias">
                Sin datos disponibles
              </div>
              <el-table-column label="Terminal" prop="terminal.attributes.nombre" />
              <el-table-column label="Agencia" prop="nombre" />
              <el-table-column align="center">
                <div slot-scope="{ row }" class="table-actions">
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="editAgencia(row)">
                    <span class="btn-inner--text">Editar</span>
                  </base-button>
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="deleteAgencia(row.id)">
                    <span class="btn-inner--text">Eliminar</span>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
      <!-- MODAL CREATE -->
      <modal :show.sync="showAddModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Crear agencia</h6>
        <form class="new-event--form" @submit.prevent="addAgencia">
          <base-input label="Nombre"
                      placeholder="Nombre de la agencia"
                      v-model="agencia.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <base-input label="Seleccione una terminal">
            <multiselect v-model="agencia.terminal" :options="terminales" :custom-label="nombreConAbreviatura" placeholder="Selecccione una terminal" label="name" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.terminal" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addAgencia">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL EDIT -->
      <modal :show.sync="showEditModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Editar agencia</h6>
        <form class="new-event--form" @submit.prevent="editAgencia">
          <base-input label="Nombre"
                      placeholder="Nombre de la agencia"
                      v-model="agencia.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <base-input label="Seleccione una terminal">
            <multiselect v-model="agencia.terminal" :options="terminales" :custom-label="nombreConAbreviatura" placeholder="Selecccione una terminal" track-by="id" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.terminal" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateAgencia">Actualizar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>
  <script>
  import Multiselect from 'vue-multiselect'
  import { BasePagination, Modal } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  import ValidationError from "@/components/ValidationError.vue";
  import formMixin from "@/mixins/form-mixin";
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      ValidationError,
      Multiselect,
      Modal,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },
    
    mixins: [formMixin],

    data() {
      return {
        agencias: [],
        terminales: [],
        selectedRows: [],
        query: null,
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 agencias por página'},
          {value:'10', descripcion: '10 agencias por página'},
          {value:'25', descripcion: '25 agencias por página'},
          {value:'50', descripcion: '50 agencias por página'}],
        },
        total: 0,
        loading: true,
        showAddModal: false,
        showEditModal: false,
        agencia: {
          type: "agencias",
          nombre: null,
          terminal: null
        }
      };
    },

    mounted() {
      this.getTerminales();
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    watch: {
      query: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
    },
  
    methods: {
      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
  
      async getList() {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { terminal: this.query } : {}),
            ...(this.query ? { nombre: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
  
        await this.$store.dispatch("agencias/list", params).then(() => {
          this.agencias = this.$store.getters["agencias/list"];
          this.total = this.$store.getters["agencias/listTotal"];
        });
        this.loading = false;
      },

      async getTerminales() {
        let params = {
          filter: {
          },
          page: {
            number: 1,
            size: 100000,
          },
        };
        await this.$store.dispatch("terminales/list", params).then(() => {
          this.terminales = this.$store.getters["terminales/list"];
        });
      },

      nombreConAbreviatura ({ nombre, abreviatura }) {
        return `${nombre} — ${abreviatura}`
      },

      closeModal() {
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showEditModal = false;
        }
        this.resetApiValidation();
        this.agencia.nombre = null;
        this.agencia.terminal = null;
      },

      async addAgencia(){
        try {
        await this.$store.dispatch("agencias/add", this.agencia);

        this.$notify({
          type: "success",
          message: "Agencia creada satisfactoriamente.",
          duration: -1
        });
        this.getList();
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      editAgencia(row) {
        this.resetApiValidation();
        this.showEditModal = true;
        this.agencia.nombre = row.nombre;
        this.agencia.terminal = this.terminales.find(item => item.id == row.terminal.id);
        this.agencia.id = row.id;
      },

      async updateAgencia() {
        try{
          await this.$store.dispatch("agencias/update", this.agencia);
          this.$notify({
            type: "success",
            message: "Agencia actualizada satisfactoriamente.",
            duration: -1
          });
          this.getList();
          this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },
  
      async deleteAgencia(id) {
        const confirmation = await swal.fire({
          title: `¿Desea eliminar esta agencia?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
            await this.$store.dispatch("agencias/destroy", id);
            await this.getList();
            this.$notify({
              type: "success",
              message: "Agencia eliminada satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
            this.$notify({
              type: "danger",
              message: "Esta agencia esta asociada al menos a un usuario.",
              duration: -1
            });
          } else {
            this.$notify({
              type: "danger",
              message: "Oops, something went wrong!",
              duration: -1
            });
          }
        }
      },
      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>